export default __webpack_public_path__ + "static/media/mvxheader.6c2db98f.svg";